import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';

const ReportedIssues = () => {
  const routes = all_routes;
  const [filterPriority, setFilterPriority] = useState('all');

  // Mock data
  const mockIssues = [
    {
      id: 1,
      ticketId: 'ISS001',
      title: 'Login System Delays',
      reporter: 'John Smith (Teacher)',
      priority: 'Critical',
      status: 'Open',
      reportDate: '2024-07-20',
      assignedTo: 'Tech Team'
    },
    {
      id: 2,
      ticketId: 'ISS002',
      title: 'Grade Display Error',
      reporter: 'Sarah Johnson (Student)',
      priority: 'High',
      status: 'In Progress',
      reportDate: '2024-07-19',
      assignedTo: 'Support Team'
    },
    {
      id: 3,
      ticketId: 'ISS003',
      title: 'Mobile App Crash',
      reporter: 'Mike Wilson (Parent)',
      priority: 'Medium',
      status: 'Resolved',
      reportDate: '2024-07-18',
      assignedTo: 'Dev Team'
    }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Open': return 'badge-soft-danger';
      case 'In Progress': return 'badge-soft-warning';
      case 'Resolved': return 'badge-soft-success';
      case 'Closed': return 'badge-soft-secondary';
      default: return 'badge-soft-secondary';
    }
  };

  const getPriorityColor = (priority: string) => {
    switch (priority) {
      case 'Critical': return 'badge-soft-danger';
      case 'High': return 'badge-soft-warning';
      case 'Medium': return 'badge-soft-primary';
      case 'Low': return 'badge-soft-success';
      default: return 'badge-soft-secondary';
    }
  };

  const stats = {
    total: mockIssues.length,
    open: mockIssues.filter(i => i.status === 'Open').length,
    inProgress: mockIssues.filter(i => i.status === 'In Progress').length,
    resolved: mockIssues.filter(i => i.status === 'Resolved').length
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.supportDashboard}>Support Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Reported Issues</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="row">
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-primary-transparent me-3">
                      <i className="ti ti-bug"></i>
                    </div>
                    <div>
                      <h4>{stats.total}</h4>
                      <p className="text-muted mb-0">Total Issues</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-danger-transparent me-3">
                      <i className="ti ti-alert-circle"></i>
                    </div>
                    <div>
                      <h4>{stats.open}</h4>
                      <p className="text-muted mb-0">Open</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-warning-transparent me-3">
                      <i className="ti ti-progress"></i>
                    </div>
                    <div>
                      <h4>{stats.inProgress}</h4>
                      <p className="text-muted mb-0">In Progress</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-success-transparent me-3">
                      <i className="ti ti-check"></i>
                    </div>
                    <div>
                      <h4>{stats.resolved}</h4>
                      <p className="text-muted mb-0">Resolved</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Issues Table */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Bug Reports & Issues</h4>
                  <div className="d-flex gap-2">
                    <button className="btn btn-primary btn-sm">
                      <i className="ti ti-plus me-1"></i>Report Issue
                    </button>
                    <button className="btn btn-outline-primary btn-sm">
                      <i className="ti ti-download me-1"></i>Export
                    </button>
                  </div>
                </div>

                <div className="card-body border-bottom">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Search Issues</label>
                      <input type="text" className="form-control" placeholder="Search by title, reporter..." />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Filter by Priority</label>
                      <select 
                        className="form-select"
                        value={filterPriority}
                        onChange={(e) => setFilterPriority(e.target.value)}
                      >
                        <option value="all">All Priorities</option>
                        <option value="Critical">Critical</option>
                        <option value="High">High</option>
                        <option value="Medium">Medium</option>
                        <option value="Low">Low</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Filter by Status</label>
                      <select className="form-select">
                        <option>All Status</option>
                        <option>Open</option>
                        <option>In Progress</option>
                        <option>Resolved</option>
                        <option>Closed</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">&nbsp;</label>
                      <button className="btn btn-outline-secondary w-100">
                        <i className="ti ti-filter me-1"></i>Reset
                      </button>
                    </div>
                  </div>
                </div>

                <div className="card-body border-bottom">
                  <div className="alert alert-info">
                    <h6><i className="ti ti-info-circle me-2"></i>TODO: Connect to issue tracking API</h6>
                    <ul className="mb-0">
                      <li>Fetch reported issues from database</li>
                      <li>Update issue status and assignments</li>
                      <li>Generate issue resolution reports</li>
                    </ul>
                  </div>
                </div>

                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Ticket ID</th>
                          <th>Issue Title</th>
                          <th>Reporter</th>
                          <th>Priority</th>
                          <th>Status</th>
                          <th>Assigned To</th>
                          <th>Report Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mockIssues.map((issue) => (
                          <tr key={issue.id}>
                            <td>
                              <Link to="#" className="text-primary fw-semibold">
                                {issue.ticketId}
                              </Link>
                            </td>
                            <td>
                              <div>
                                <h6 className="mb-0">{issue.title}</h6>
                              </div>
                            </td>
                            <td>{issue.reporter}</td>
                            <td>
                              <span className={`badge ${getPriorityColor(issue.priority)}`}>
                                {issue.priority}
                              </span>
                            </td>
                            <td>
                              <span className={`badge ${getStatusColor(issue.status)}`}>
                                {issue.status}
                              </span>
                            </td>
                            <td>
                              <span className="badge bg-light text-dark">
                                {issue.assignedTo}
                              </span>
                            </td>
                            <td>{issue.reportDate}</td>
                            <td>
                              <div className="dropdown">
                                <button className="btn btn-white btn-sm dropdown-toggle" data-bs-toggle="dropdown">
                                  Actions
                                </button>
                                <ul className="dropdown-menu">
                                  <li><button className="dropdown-item"><i className="ti ti-eye me-2"></i>View Details</button></li>
                                  <li><button className="dropdown-item"><i className="ti ti-edit me-2"></i>Update Status</button></li>
                                  <li><button className="dropdown-item"><i className="ti ti-user me-2"></i>Reassign</button></li>
                                  <li><button className="dropdown-item"><i className="ti ti-message me-2"></i>Add Comment</button></li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportedIssues;
